import React from 'react';
import SearchIcon from '../../../assets/icons/icon_search.svg';
import { SearchState } from './SearchTab';
import './SearchHeader.css';

interface SearchHeaderProps {
  searchQuery: string;
  onSearchFocus: () => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchSubmit: () => void;
  onCancelSearch: () => void;
  searchState: SearchState;
}

const SearchHeader: React.FC<SearchHeaderProps> = ({
  searchQuery,
  onSearchFocus,
  onSearchChange,
  onSearchSubmit,
  onCancelSearch,
  searchState
}) => {
  return (
    <header className="search-header">
      {searchState === 'initial' && <h1>Search</h1>}
      <div className={`search-input-container ${searchQuery.length === 0 ? 'full-width' : ''}`}>
        <input
          type="text"
          placeholder="Search Vivid"
          className="search-input"
          value={searchQuery}
          onChange={onSearchChange}
          onFocus={onSearchFocus}
          onKeyPress={(e) => e.key === 'Enter' && onSearchSubmit()}
        />
        <img src={SearchIcon} alt="Search" className="search-icon" />
        {searchQuery.length > 0 && (
          <button className="search-cancel-button" onClick={onCancelSearch}>
            Cancel
          </button>
        )}
      </div>
    </header>
  );
};

export default SearchHeader;

